import React, { ReactNode } from 'react';
import { createSignalRContext } from 'react-signalr';
import { getToken, useIsAuthenthicated } from '../auth';

const SignalRContext = createSignalRContext();

export const SignalRProvider = ({ children }: { children: ReactNode }) => {
  const isAuthenticated = useIsAuthenthicated();

  return (
    <SignalRContext.Provider
      connectEnabled={isAuthenticated}
      accessTokenFactory={async () => (isAuthenticated ? (await getToken()) ?? '' : '')}
      dependencies={[isAuthenticated]}
      url="/api/portalhub"
    >
      {children}
    </SignalRContext.Provider>
  );
};

export const useSignalREffect = SignalRContext.useSignalREffect;

export default SignalRContext;
